import * as React from 'react';

import * as styles from './styles.css';
import { OptionalAnchor } from '../OptionalAnchor';

export interface IAboutBuildingProps {
  buildingInfo?: string;
  link?: string;
  name?: string;
  linkTarget?: string;
  onLinkClick(): void;
  isBooked?: boolean;
}

export class AboutBuilding extends React.Component<IAboutBuildingProps> {
  public render() {
    const { name, buildingInfo, isBooked } = this.props;

    return (
      <div className={styles['container']}>
        {name && (
          <OptionalAnchor
            href={this.props.link}
            rel="noopener"
            target={this.props.linkTarget}
            className={isBooked ? styles['name--booked'] : styles['name']}
            onAnchorClick={this.handleLinkClick}
          >
            {name}
          </OptionalAnchor>
        )}
        {buildingInfo && (
          <div className={isBooked ? styles['building-info--booked'] : styles['building-info']}>{buildingInfo}</div>
        )}
      </div>
    );
  }

  /* istanbul ignore next */
  private handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();

    this.props.onLinkClick();
  };
}
